import(/* webpackMode: "eager" */ "/builds/aleksundshantu/toni-hofreiter-2026-frontend/apps/template-standard/src/app/global-error.tsx");
